import { Button, Modal, Label, TextInput } from "flowbite-react";
import { useForm } from "react-hook-form";
import { City } from "@/sharedTypes";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface CityFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: City) => void;
  defaultValues?: City;
  mode?: "create" | "edit";
  errorMessage?: string;
}

export default function CityFormDialog({
  open,
  onClose,
  onSubmit,
  defaultValues,
  mode = "create",
  errorMessage,
}: CityFormDialogProps) {
  const { t } = useTranslation(["temporalActivity", "common"]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<City>();

  useEffect(() => {
    if (open) {
      reset(
        defaultValues || {
          city_name: "",
        }
      );
    }
  }, [open, defaultValues, reset]);

  return (
    <Modal show={open} onClose={onClose}>
      <Modal.Header>
        {mode === "edit" ? t("temporalActivity:city.edit") : t("temporalActivity:city.create")}
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <div className="mb-2 block">
              <Label htmlFor="city_name" value={t("temporalActivity:city.name")} />
            </div>
            <TextInput
              id="city_name"
              placeholder={t("temporalActivity:city.namePlaceholder")}
              {...register("city_name", {
                required: t("temporalActivity:city.nameRequired") as string,
              })}
              color={errors.city_name ? "failure" : "gray"}
              helperText={errors.city_name?.message}
            />
          </div>

          {errorMessage && <div className="text-sm text-red-500">{errorMessage}</div>}

          <div className="flex justify-end gap-x-2">
            <Button color="gray" onClick={onClose}>
              {t("common:cancel")}
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {mode === "edit" ? t("common:save") : t("common:create")}
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
